import React from 'react';
import ReactDOM from 'react-dom';

import './assets/styles/styles.scss';

import Layout from "./components/Layout";


ReactDOM.render(
    <React.StrictMode>
            <Layout/>
    </React.StrictMode>,
    document.getElementById('root')
);
